import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useModuleData from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import { Table } from "antd";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import ChildSupportCalculations from "./ChildSupportCalculations";
import IncomeAdjustments from "./IncomeAdjustments";
import ChildRelatedExpenses from "./ChildRelatedExpenses";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const moduleNames = [
  "Child Support Calculations",
  "Child Related Expenses",
  "Income Adjustments",
];

export default function SupportCalculations() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState(
    "Child Support Calculations",
    "Child Related Expenses",
    "Income Adjustments"
  );
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );

  console.log("Attributes Data:", attributes);
  console.log("Disaster Attributes", disasterAttribute);

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading);

  const tableDataObj = {
    "Support Calculations": tableData.supportCalculationsData,
    "Child Support Calculations": tableData.childSupportCalculationsData,
    "Child Related Expenses": tableData.childRelatedExpensesData,
    "Income Adjustments": tableData.incomeAdjustmentsData,
  };

  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/orgainzer/important-document");
  };

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="parent-title">Support Calculations</h2>
          <ToolTipCreator name={"Divorce_Support_Calculations"}/>
        </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>
      <ChildSupportCalculations />
     <IncomeAdjustments />
     <ChildRelatedExpenses />
      <NewLoader isLoading={loading} />
    </div>
  );
}
